import { Badge, BadgeSize, BadgeVariant } from "@/components/ui/Badge";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { useTruncatedList } from "@/hooks/useTruncatedList";

interface TruncatedPermissionsBadgesProps {
  permissions: string[];
}

export const TruncatedPermissionsBadges = ({ permissions }: TruncatedPermissionsBadgesProps) => {
  const { containerRef, measureRef, visibleCount, hiddenCount } = useTruncatedList({
    itemCount: permissions.length,
    keepMinOne: true,
  });

  if (permissions.length === 0) {
    return <div className="flex h-full items-center text-sm text-gray-400">&mdash;</div>;
  }

  return (
    <div
      ref={containerRef}
      className="relative flex h-full w-full min-w-0 flex-1 items-center gap-1"
    >
      <div
        ref={measureRef}
        className="pointer-events-none invisible absolute flex w-full gap-1"
        aria-hidden="true"
      >
        {permissions.map(permission => (
          <Badge key={permission} variant={BadgeVariant.GRAY} size={BadgeSize.SM}>
            {permission}
          </Badge>
        ))}
      </div>
      {permissions.slice(0, visibleCount).map(permission =>
        hiddenCount > 0 ? (
          <BasicTooltip key={permission} content={permission}>
            <span>
              <Badge variant={BadgeVariant.GRAY} size={BadgeSize.SM}>
                {permission}
              </Badge>
            </span>
          </BasicTooltip>
        ) : (
          <Badge key={permission} variant={BadgeVariant.GRAY} size={BadgeSize.SM}>
            {permission}
          </Badge>
        ),
      )}
      {hiddenCount > 0 && (
        <BasicTooltip content={permissions.slice(visibleCount).join(", ")}>
          <span>
            <Badge variant={BadgeVariant.GRAY} size={BadgeSize.SM}>
              +{hiddenCount}
            </Badge>
          </span>
        </BasicTooltip>
      )}
    </div>
  );
};
